// extracted by mini-css-extract-plugin
module.exports = {"icon":"FJNoMedia_icon__1FEXF","icon_small":"FJNoMedia_icon_small__1CidW","desc":"FJNoMedia_desc__251fo"};